export default __webpack_public_path__ + "static/image10-019c66ea3c30f162b8d78268a19791b8.webp";